module.exports = [{"id":"01","email":"max@test.de","password":"1234","firstName":"Max","lastName":"Mustermann","gender":"male","birthdate":"10.01.1992","address":"Himmelweg 12, Schönendorf 1234","roles":["nomrmal"],"telefon":"0412-3345678"},{"id":"02","email":"lisa@test.de","password":"5678","firstName":"Lisa","lastName":"Lalala","gender":"female","birthdate":"20.05.1988","address":"Musterstraße 12, Musterdorf 1234","roles":["vip"],"telefon":"0412-78929238"}]


//////////////////
// WEBPACK FOOTER
// ./src/data/CustomerData.json
// module id = 491
// module chunks = 0